// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"2dfd6951","306":"28dd45d5","459":"4e4aad88"}[chunkId] + ".chunk.js";
};